const PageSizeState = {
    FULL: 0,
    SHORT: 1,
    FULL_NO_HEADER: 2,
    LOCK: 3,
};

export default PageSizeState;
